export const VIEWPORT_DOUBLE_CLICK_MAXIMIZE_MARKER = 'KAIROS_QOL2_VIEWPORT_DOUBLE_CLICK_MAXIMIZE';

export const normalizeViewportIndex = (index, total) => {
  const n = Number(index);
  const count = Number(total);
  if (!Number.isInteger(n) || n < 0) return null;
  if (Number.isInteger(count) && count > 0 && n >= count) return null;
  return n;
};

export const toggleMaximizedViewport = (currentIndex, requestedIndex, total) => {
  const next = normalizeViewportIndex(requestedIndex, total);
  if (next === null) return null;
  return currentIndex === next ? null : next;
};

export const isViewportVisibleInMaximizeMode = (viewportIndex, maximizedIndex) => (
  maximizedIndex === null || maximizedIndex === undefined || viewportIndex === maximizedIndex
);
